/* Wishlist -> Omnisend + Shopify Customer Events.
   Listens to mc:wishlist:add from mc-wishlist.js (that file is not modified).
   - Omnisend: "added product to wishlist" (recorded only for identified contacts)
   - Shopify.analytics.publish('mc_wishlist_add') for the Meta / GA4 custom pixel (all visitors)
   - Fills in missing title/price/url by fetching the product when the cache is empty
   - After a contact is identified (mc:omnisend:identified), re-sends the current saved items */
(function () {
  if (window.__mcWishlistOmnisend) return;
  window.__mcWishlistOmnisend = true;

  var SENT_KEY = 'mc_wl_omnisend_sent';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readMap() { try { return JSON.parse(sessionStorage.getItem(SENT_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function writeMap(m) { try { sessionStorage.setItem(SENT_KEY, JSON.stringify(m)); } catch (e) {} }
  function sentRecently(id) { var m = readMap(); return m[id] && Date.now() - m[id] < 30 * 60 * 1000; }
  function markSent(id) { var m = readMap(); m[id] = Date.now(); writeMap(m); }

  function readRich() { try { return JSON.parse(localStorage.getItem('mc_wishlist') || '[]') || []; } catch (e) { return []; } }
  function richOf(id) { return readRich().filter(function (x) { return String(x.id) === String(id); })[0]; }
  function absImg(src) { src = src ? String(src) : ''; return src.indexOf('//') === 0 ? 'https:' + src : src; }
  function absUrl(u) {
    if (!u) return location.origin;
    return /^https?:\/\//.test(u) ? u : location.origin + (u.charAt(0) === '/' ? '' : '/') + u;
  }
  function currency() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; }

  function handleFor(id, hint) {
    if (hint) return hint;
    var it = richOf(id);
    if (it && it.handle) return it.handle;
    var btn = document.querySelector('.t4s-pr-wishlist[data-id="' + id + '"]');
    var m;
    if (btn) {
      if (btn.dataset && btn.dataset.handle) return btn.dataset.handle;
      m = String(btn.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
      var card = btn.closest('[data-product-id], .t4s-product, .product-item, article, li');
      var a = card && card.querySelector('a[href*="/products/"]');
      m = a && String(a.getAttribute('href')).match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  // Returns a promise of { id, variantID, currency, price, title, imageUrl, url }
  function buildProduct(d) {
    var id = String(d.productId);
    var it = richOf(id) || {};
    var p = {
      id: id,
      variantID: d.variantId ? String(d.variantId) : (it.variantId ? String(it.variantId) : ''),
      currency: currency(),
      price: typeof d.price === 'number' ? Math.round(d.price) / 100 : (typeof it.price === 'number' ? Math.round(it.price) / 100 : 0),
      title: d.title || it.title || '',
      imageUrl: absImg(it.image),
      url: absUrl(d.url || it.url || (d.handle ? root + 'products/' + d.handle : ''))
    };
    if (p.title && p.price && p.imageUrl) return Promise.resolve(p);
    var handle = handleFor(id, d.handle || it.handle);
    if (!handle) return Promise.resolve(p);
    return fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return p;
        var v = (j.variants || []).filter(function (x) { return x.available; })[0] || (j.variants || [])[0] || {};
        p.title = p.title || j.title || '';
        if (!p.price) p.price = Math.round(v.price != null ? v.price : j.price) / 100;
        if (!p.variantID && v.id) p.variantID = String(v.id);
        if (!p.imageUrl) p.imageUrl = absImg(j.featured_image || (j.images && j.images[0]) || '');
        if (!d.url && !it.url) p.url = absUrl(j.url || (root + 'products/' + j.handle));
        return p;
      })
      .catch(function () { return p; });
  }

  function trackOmnisend(product, listName) {
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['track', 'added product to wishlist', {
        origin: 'api',
        properties: { product: product, listName: listName || '' }
      }]);
    } catch (err) {}
  }

  function publishShopify(product) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('mc_wishlist_add', {
          product_id: product.id,
          variant_id: product.variantID,
          title: product.title,
          price: product.price,
          currency: product.currency,
          url: product.url
        });
      }
    } catch (err) {}
  }

  document.addEventListener('mc:wishlist:add', function (e) {
    var d = (e && e.detail) || {};
    var id = d.productId ? String(d.productId) : '';
    if (!id || sentRecently(id)) return;
    markSent(id);
    buildProduct(d).then(function (product) {
      trackOmnisend(product, d.listName);
      publishShopify(product);
    });
  });

  // A contact was just identified: anything saved earlier in this browser was
  // dropped by Omnisend (anonymous), so send the current saved items again.
  document.addEventListener('mc:omnisend:identified', function () {
    writeMap({});
    var items = [];
    try { items = (window.MCWishlist && MCWishlist.all()) || []; } catch (err) {}
    items.slice(0, 20).forEach(function (it, i) {
      setTimeout(function () {
        buildProduct({ productId: it.id, variantId: it.variantId, title: it.title, price: it.price, url: it.url, handle: it.handle })
          .then(function (product) { markSent(String(it.id)); trackOmnisend(product, ''); });
      }, 600 + i * 150);
    });
  });
  // Shared with mc-wishlist-plus.js ("Email me this list")
  window.MCWishlistOmnisend = { buildProduct: buildProduct };
})();
